// Fallback for footerBox.destinationURL. Org configs store this per-org and may
// leave it empty, in which case the footer logo would render unlinked.
// UTM params match the previous parcelperform.com link so marketing attribution
// stays continuous across the rebrand.
export const DEFAULT_FOOTER_DESTINATION_URL =
  'https://www.perform.ai/?utm_source=PP-logo&utm_medium=referral&utm_campaign=premium-tracking-page&utm_content=powered-by-PP';
